// extracted by mini-css-extract-plugin
export var buttonContainer = "styles-module--buttonContainer--6c380";
export var content = "styles-module--content--06a86";
export var icon = "styles-module--icon--02a4b";
export var image = "styles-module--image--43d1a";
export var number = "styles-module--number--291b9";
export var phoneNumber = "styles-module--phoneNumber--75c74";
export var section = "styles-module--section--0fc2d";